import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import QtyNumberInput, {
  QtyNumberInputProps
} from '@modules/order/components/CellTemplates/components/QtyNumberInput/QtyNumberInput'
import { stores } from '@stores'
import { useObserver } from 'mobx-react-lite'
import React, { forwardRef } from 'react'

export interface IASizedQuantityProps extends QtyNumberInputProps {
  mainOrderProductSizeValue: any
}

const useStyles = makeStyles(theme => ({
  IASizeQuantityWrapper: {
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  productSizeValue: {
    width: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const IASizedQuantity = forwardRef<HTMLInputElement, IASizedQuantityProps>(
  ({ mainOrderProductSizeValue, value, ...props }, ref) =>
    useObserver(function useHook() {
      const classes = useStyles()
      const {
        productConfiguration: { featureFlags }
      } = stores
      return (
        <div className={classes.IASizeQuantityWrapper}>
          <CentricTypography className={classes.productSizeValue} variant={'h6DarkGrey'}>
            {mainOrderProductSizeValue}
          </CentricTypography>
          <QtyNumberInput
            {...props}
            ref={ref}
            value={value}
            highlightInput={
              featureFlags?.highlightQuantityDiscrepancies &&
              mainOrderProductSizeValue < value
            }
          />
        </div>
      )
    })
)

export default IASizedQuantity
